import { Component, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CreateProjectService } from '../services/create-project.service';
import { toHTML } from 'ngx-editor';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { SaveDraftDialogComponent } from '../save-draft-dialog/save-draft-dialog.component';
import { DashboardService } from '../services/dashboard.service';
import { RoleViewService } from '../services/role-view.service';
import { NotificationService } from '../services/notification.service';
import { SelectProjectTabComponent } from '../select-project-tab/select-project-tab.component';
import { SelectCollectionComponent } from '../select-collection/select-collection.component';
import { SelectDepartmentComponent } from '../select-department/select-department.component';
import { SelectEmailComponent } from '../select-email/select-email.component';
import { SelectAttachmentsComponent } from '../select-attachments/select-attachments.component';
import { SummaryComponent } from '../summary/summary.component';

@Component({
  selector: 'app-managedocuments',
  standalone: true,
  imports: [CommonModule, MatStepperModule,
    MatIconModule, MatButtonModule, MatDialogModule, MatTooltipModule,
    SelectProjectTabComponent,
    SelectCollectionComponent,
    SelectDepartmentComponent,
    SelectEmailComponent,
    SelectAttachmentsComponent,
    SummaryComponent
  ],
  templateUrl: './managedocuments.component.html',
  styleUrl: './managedocuments.component.css'
})
export class ManagedocumentsComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('submitDialog') submitDialog!: TemplateRef<any>;
  @ViewChild('successDialog') successDialog!: TemplateRef<any>;
  isLinear = true;
  stepItems = ['Project Name', 'Collection Name', 'Department', 'Email draft', 'Documents', 'Summary']
  selectedStep = 0;
  isButtonDisabled = true;
  selectedCollection: any = null;
  selectedSubCollections: any[] = [];
  projectForm!: FormGroup;
  showManageDocument = false;
  isCollectionValid = false;
  selectedDepartmentIds: string[] = [];
  selectedMembers: any[] = [];
  isDeptAndMembersValidCtrl = new FormControl<boolean>(false, { nonNullable: true });
  emailForm!: FormGroup;
  stepStatus: ('normal' | 'completed')[] = new Array(this.stepItems.length).fill('normal');
  attachmentsSelectedCount = 0;
  collectionPayload: any;
  userRole: any;
  workDayId = '';
  allMembers: Record<string, any[]> = {};
  emails: string[] = [];
  ccEmails: string[] = [];
  bccEmails: string[] = [];
  isSummaryPageActive = false;
  isAttachmentRed = false;
  projectId = '';
  isCopyMode = false;
  selectedDepartments: any[] = [];
  // Indicates the create-project flow has been finally submitted
  isSubmitted = false;
  readonly Date = Date;
  collectionId: any;
  subCollectionIds: any[] = [];
  selectedDeptData: any;
  preSelectedDepartments: Array<{ id: string; name: string }> = [];
  // Keyed by department id so a pre-selected member id is only ever applied
  // back to the department it actually belonged to in the source project.
  selectedMemberData: Record<string, string[]> = {};
  userName: any;
  deptToAddress: string[] = [];       // emails from selected dept members
  externalToAddress: string[] = [];   // emails manually added by user
  constructor(
    public fb: FormBuilder,
    public createProjectService: CreateProjectService,
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dashboardService: DashboardService,
    private readonly roleviewservice: RoleViewService,
    private readonly notificationService: NotificationService,
    private readonly location: Location
  ) {
  }
  ngOnInit() {
    this.getUserInfo();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.isCopyMode = this.route.snapshot.queryParamMap.get('mode') === 'copy';
      if (id) {
        if (this.isCopyMode) {
          // Copy: load the source project's details for pre-fill, but keep the
          // projectId empty (and clear any stored id) so that saving creates a
          // brand-new project with a newly generated Project ID.
          this.createProjectService.setProjectId(null);
          // Remember the source project so the Documents step can offer its
          // existing documents to copy into the new project.
          this.createProjectService.setSourceProjectId(id);
          this.createProjectService.setSelectedSourceDocumentIds([]);
          this.projectId = '';
          this.getProjectDetailsFromDashboard(id);
        } else {
          this.createProjectService.setSourceProjectId(null);
          this.createProjectService.setSelectedSourceDocumentIds([]);
          this.projectId = id;
          console.info("Project ID from route:", this.projectId);
          this.getProjectDetailsFromDashboard();
        }
      } else {
        this.createProjectService.setSourceProjectId(null);
        this.createProjectService.setSelectedSourceDocumentIds([]);
        this.selectedStep = 0;
      }
    });

    this.createProjectForm();
    this.createEmailForm();
   
  }
  getUserInfo() {
    this.workDayId = this.roleviewservice.getWorkdayId() || '';
    this.userRole = this.roleviewservice.getAdminAsRole();
    console.info("User Role:", this.userRole, "Workday ID:", this.workDayId);
    this.userName = this.roleviewservice.getUserName();
  }

  getProjectDetailsFromDashboard(fetchId: string = this.projectId) {
    if (!fetchId) {
      return;
    }

    this.dashboardService.fetchProjectDraftDetails(fetchId).subscribe({
      next: (res) => {
        this.populateConllectionData(res.payload[0]);
        this.populateProjectForm(res.payload[0]);

        this.populateDepartmentAndMembers(res.payload[0]);
        this.populateEmailForm(res.payload[0]);
        this.selectedStep = 0;
      },
      error: (err) => {
        console.trace('Error fetching draft project details:', err);
      }
    });
  }

  populateConllectionData(collectionData: any) {
    this.collectionId = collectionData.collection_id;
    this.subCollectionIds = collectionData.sub_collection_id || [];
  }

  populateProjectForm(projectData: any) {
    this.projectForm.get('naming')?.setValue(projectData.project_name_type);
    this.projectForm.get('modelYear')?.setValue(projectData.model_year);
    this.projectForm.get('modelCode')?.setValue(projectData.model_code);
    this.projectForm.get('projectCode')?.setValue(projectData.project_code);
    this.projectForm.get('projectMasterId')?.setValue(projectData.project_master_id);
    this.projectForm.get('projectName')?.setValue(projectData.project_name);
    this.projectForm.get('contactPerson')?.setValue(projectData.contact_person);
    this.projectForm.get('instructionType')?.setValue(projectData.instruction_type);
    this.projectForm.get('documentNumber')?.setValue(projectData.document_number);
    this.projectForm.get('dueDate')?.setValue(this.parseDateOnly(projectData.due_date));
    this.createProjectService.setSelectedProject(this.projectForm.getRawValue());
  }

  populateEmailForm(emailData: any) {
    this.emailForm.get('templateId')?.setValue(emailData.template_id);
    this.emailForm.get('subject')?.setValue(emailData.subject);
    this.emailForm.get('body')?.setValue(emailData.email_body);
    this.emailForm.get('to')?.setValue(emailData.to_address ? emailData.to_address.join(', ') : '');
    this.emailForm.get('cc')?.setValue(emailData.cc_address ? emailData.cc_address.join(', ') : '');
    this.emailForm.get('bcc')?.setValue(emailData.bcc_address ? emailData.bcc_address.join(', ') : '');
    const payload = this.saveEmailPayload();
    this.createProjectService.setSelectedEmail(payload);
    this.createProjectService.setSelectedTemplateId(this.emailForm.value.templateId)
  }

  populateDepartmentAndMembers(departmentData: any) {
    // The draft API can return a placeholder entry (department_id/department_name
    // all null) when no department was actually selected/saved - filter those out
    // so a phantom "null" department doesn't show up as selected when editing.
    const validDepartments = (departmentData.departments || []).filter(
      (d: any) => d?.department_id !== null && d?.department_id !== undefined && d.department_id !== ''
    );
    this.selectedDeptData = validDepartments.map((d: any) => String(d.department_id));
    this.preSelectedDepartments = validDepartments.map((d: any) => ({
      id: String(d.department_id),
      name: String(d.department_name || d.departmentName || d.name || d.department_id)
    }));
    this.selectedMemberData = validDepartments.reduce((acc: Record<string, string[]>, item: any) => {
      const deptId = String(item.department_id);
      const memberIds = (item.selected_tm_id || [])
        .filter((id: any) => id !== null && id !== undefined)
        .map((id: any) => String(id));
      if (memberIds.length) { acc[deptId] = memberIds; }
      return acc;
    }, {});
  }

  hasUnsavedChanges(): boolean {
    try {
      const hasCollection = this.isCollectionValid;
      const hasProject = this.projectForm?.dirty || !!this.createProjectService.getSelectedProject();
      const hasDeptAndMembers = this.isDeptAndMembersValidCtrl.value || (this.selectedMembers && this.selectedMembers.length > 0);
      const hasEmail = this.emailForm?.dirty || !!this.createProjectService.getSelectedEmail();
      const hasAttachments = this.attachmentsSelectedCount > 0;
      const onSummary = !!this.isSummaryPageActive;
      return !!(hasCollection || hasProject || hasDeptAndMembers || hasEmail || hasAttachments || onSummary);
    } catch {
      return false;
    }
  }


  onNext() {
    if (this.isNextEnable()) {
      if (this.selectedStep === 0) {
        const projectId = this.createProjectService.getProjectId()
        if (projectId) {
          this.collectionPayload.projectId = projectId
        }
        this.incrementSelectedstep();
      } else if (this.selectedStep === 1) {
        this.saveProjectDetailsData();
      } else if (this.selectedStep === 2) {
        this.saveDepartmentDetails();
      } else if (this.selectedStep === 3) {
        // Build recipients and save email details
        this.buildEmailRecipients();
        this.saveEmailDetails();
      } else if (this.selectedStep === 4) {
        this.isSummaryPageActive = true;
        this.isAttachmentRed = true;
        this.incrementSelectedstep();
      }
    }
  }

  incrementSelectedstep() {
    this.selectedStep++;
    this.stepper.selectedIndex = this.selectedStep;
  }

  isCompleted(index: number) {

    if (this.selectedStep == null || index > this.selectedStep) {
      return false;
    }

    if (index === 0) {
      return this.isCollectionValid;
    }
    if (index === 1) {
      return this.projectForm.valid;
    }
    if (index === 2) {
      return this.isDeptAndMembersValidCtrl.value;
    }
    if (index === 3) {
      return this.emailForm.valid;
    }
    if (index === 4) {
      return this.isAttachmentRed;
    }
    if (index === 5) {
      return this.isSummaryPageActive;
    }
    return false;
  }

  onStepClick(event: StepperSelectionEvent): void {
    this.selectedStep = event.selectedIndex;
    if (this.selectedStep === 2 && !this.createProjectService.getSelectedEmail()) {
      this.clearEmailTemplateSelection();
    }
    // When navigating to Documents tab (step 4), refresh the selected department IDs
    if (this.selectedStep === 4) {
      // The SelectAttachmentsComponent will read the latest department IDs from the service during ngOnInit
      // But we need to ensure it refreshes if user went back to department selection
      // This will be handled by the component itself
    }
  }

  goToStep(stepIndex: number): void {
    this.selectedStep = stepIndex;
  }

  getStepIcon(index: number): string {
    const icons = ['work_outline', 'folder', 'business', 'email', 'attach_file', 'done_all'];
    return icons[index];
  }

  onStepChange(event: StepperSelectionEvent) {
    const currentIndex = event.selectedIndex;
    this.stepStatus.forEach((_, index) => {
      if (index < currentIndex) {
        this.stepStatus[index] = 'completed';
      } else {
        this.stepStatus[index] = 'normal';
      }
    });

    if (event.previouslySelectedIndex > currentIndex) {
      for (let i = currentIndex + 1; i < this.stepItems.length; i++) {
        const step = this.stepper.steps.toArray()[i];
        step.reset();
      }
    }
  }

  scrollToStep(index: number) {
    const stepElement = document.querySelectorAll('.step-item')[index];
    if (stepElement) {
      stepElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onPrevious() {
    if (this.selectedStep > 0) {
      this.selectedStep--;
      this.stepper.selectedIndex = this.selectedStep;
    }
    if (this.selectedStep === 2 && !this.createProjectService.getSelectedEmail()) {
      this.clearEmailTemplateSelection();
    }
  }
  handleButtonState(payload: any) {
    this.collectionPayload = payload.data;
    // Set valid when we have collection data with ID
    this.isCollectionValid = !!payload.data?.collectionId;
    console.info("***", this.isCollectionValid)
  }
  selectStep(index: number) {
    if (index <= this.selectedStep) {
      this.selectedStep = index;
    }
  }
  createProjectForm() {
    this.projectForm = this.fb.group({
      // naming: ['standard', Validators.required],
      modelYear: [''],
      modelCode: [''],
      projectCode: [''],
      projectName: [{ value: '' }],
      projectMasterId: ['', Validators.required],
      contactPerson: ['', Validators.required],
      instructionType: ['', Validators.required],
      documentNumber: ['', Validators.required],
      dueDate: ['']
    });
  }
  loadMembersForDepartments(departments: any[]) {
    departments.forEach(dept => {
      this.allMembers[dept.id] = dept.teamDetails.map((m: any) => ({
        ...m,
        selected: false   // Initially none selected
      }));
    });

    // Optionally pre-select departments
    this.selectedDepartmentIds = departments.map(d => String(d.id));
  }
  updateSelectedMembers() {
    this.selectedMembers = this.selectedDepartmentIds.reduce((acc: any[], deptId) => {
      const members = (this.allMembers[deptId] || []).filter(m => m.selected);
      return acc.concat(members);
    }, []);

    console.info('Currently selected members:', this.selectedMembers.map(m => m.name));

    this.updateValidityCtrl();
  }


  saveProjectDetailsData() {
    if (this.projectForm.valid) {
      this.createProjectService.setSelectedProject(this.projectForm.getRawValue());

      const { naming, contactPersonSelected, ...formData } = this.projectForm.getRawValue();

      const payload = {
        ...this.collectionPayload,
        ...formData,
        projectId: this.projectId,
        naming,
        dueDate: this.formatDate(formData.dueDate),
        createdBy: this.userName
      };
      this.createProjectService.saveProjectDetails(payload).subscribe(res => {
        if (res?.payload?.projectId) {
          this.projectId = String(res.payload.projectId);
          // Store projectId in service for use across components
          this.createProjectService.setProjectId(this.projectId);
          if (this.isCopyMode) {
            this.isCopyMode = false;
            this.location.replaceState(`/manage-documents/${this.projectId}`);
          }
          console.info('Project ID set from project details step:', this.projectId);
        }
        this.incrementSelectedstep();
      });
    }


  }

  onSelectedDepartmentsChange(depts: any[]) {
    this.selectedDepartments = depts;
    this.selectedDepartmentIds = depts.map(d => String(d.id));
    this.updateValidityCtrl();
  }

  saveDepartmentDetails() {
    if (!this.selectedMembers || this.selectedMembers.length === 0) {
      console.info('No members selected in any department.');
      return;
    }

    if (!this.projectId) {
      console.trace('Project ID is missing. Cannot save department details.');
      return;
    }

    // Get unique department IDs from selected members
    const deptIds = Array.from(new Set(this.selectedMembers.map(m => String(m.tm_dept_id))));

    // Build departmentDetails array
    const departmentDetails = deptIds.map(deptId => {
      const members = this.selectedMembers.filter(m => String(m.tm_dept_id) === deptId);

      // Get department name from selectedDepartments
      const dept = this.selectedDepartments.find(d => String(d.id) === deptId);
      const departmentName = dept?.name || '';

      const teamDetails = members.map(m => ({
        tm_workday_id: m.tm_workday_id,
        tm_name: m.tm_name || m.name || '',
        tm_email: m.tm_email || m.email || ''
      }));

      return {
        departmentId: deptId,
        departmentName: departmentName,
        teamDetails: teamDetails,
        selectedAll: false
      };
    });

    const payload = {
      projectId: this.projectId,
      departmentDetails
    };

    console.info('Payload to save team members:', departmentDetails);

    this.createProjectService.saveTeammemberDetails(this.workDayId, payload)
      .subscribe({
        next: res => {
          console.info('Team members saved successfully:', res);
          this.deptToAddress = this.selectedMembers.map(m => m.email).filter(e => e?.trim().length > 0);
           this.createProjectService.setSelectedEmail(this.deptToAddress);
          this.createProjectService.setSelectedDepartment({
            selectedDepartments: this.selectedDepartments.map(d => ({ id: d.id, name: d.name })),
            selectedMembers: this.selectedMembers
          });
          
          this.selectedDeptData = this.selectedDepartments.map(d => String(d.id));
          this.preSelectedDepartments = this.selectedDepartments.map(d => ({ id: String(d.id), name: String(d.name || '') }));
          // this.selectedMemberData = this.selectedMembers.reduce((acc: Record<string, string[]>, m: any) => {
          //   const deptId = String(m.tm_dept_id);
          //   (acc[deptId] ||= []).push(String(m.tm_workday_id));
          //   return acc;
          // }, {});

          this.selectedMemberData = this.selectedMembers.reduce((acc: Record<string, string[]>, m: any) => {
            const deptId = String(m.tm_dept_id);
            acc[deptId] = acc[deptId] || [];
            acc[deptId].push(String(m.tm_workday_id));
            return acc;
          }, {} as Record<string, string[]>);

          this.incrementSelectedstep();
        },
        error: err => {
          console.trace('Error saving team members:', err);
          const errorMsg = err?.error?.message || 'Failed to save department/team member details. Please try again.';
          this.notificationService.showError(errorMsg);
        }
      });
  }



  onSelectedMembersChange(members: any[]) {
    this.selectedMembers = members;

    // Get unique department IDs from selected members
    this.selectedDepartmentIds = Array.from(new Set(members.map(m => String(m.tm_dept_id))));

    // Update parent allMembers to mark selected members
    this.selectedDepartmentIds.forEach(deptId => {
      const deptMembers = this.allMembers[deptId] || [];
      deptMembers.forEach(m => {
        m.selected = members.some(sel => (sel.tm_workday_id === m.tm_workday_id));
      });
    });

    this.updateValidityCtrl();

    console.info('Updated allMembers:', this.allMembers);
  }

  private updateValidityCtrl() {
    const isValid =
      this.selectedDepartments.length > 0 &&
      this.selectedDepartments.every(dept =>
        this.selectedMembers.some(member => member.tm_dept_id === dept.id)
      );


    console.info(" this.selectedDepartmentIds", this.selectedDepartments)
    this.isDeptAndMembersValidCtrl.setValue(isValid, { emitEvent: true });
  }



  isNextEnable() {
    return (this.selectedStep === 0 && this.projectForm.valid)
      || (this.selectedStep === 1 && this.isCollectionValid)
      || (this.selectedStep === 2 && this.isDeptAndMembersValidCtrl.value)
      || (this.selectedStep === 3 && this.emailForm.valid)
      || this.selectedStep === 4;
  }

  handleEmailFormValue(emailData: any) {
    console.info('Email form data received:', emailData);
    // The emailForm is already updated via the form binding, but we can handle additional logic here if needed
  }
  onAttachmentsSelectedCount(count: number) {
    this.attachmentsSelectedCount = count;
  }

  createEmailForm() {
    console.info("this.email", this.emails);
    this.emailForm = new FormGroup({
      to: new FormControl(''),
      cc: new FormControl(''),
      bcc: new FormControl(''),
      subject: new FormControl('', [Validators.required]),
      body: new FormControl('', [Validators.required]),
      templateId: new FormControl('')
    });
  }

  private buildEmailRecipients() {
    // Get emails from selected department members
    const deptEmails = this.createProjectService.getSelectedDepartment()?.selectedMembers.map((member: any) => member.email) || [];

    // Get emails from the "to" field in email form
    const toFieldValue = this.emailForm?.value?.to || '';
    const toEmails = toFieldValue.split(',').map((e: string) => e.trim()).filter(Boolean);

    // Combine both and remove duplicates
    this.emails = Array.from(new Set([...(deptEmails || []), ...toEmails]));
  }

  saveEmailPayload() {
    const ccValue = this.emailForm.value.cc;
    const bccValue = this.emailForm.value.bcc;

    // Derive externalToAddress from the form's "to" field (emails not already in deptToAddress)
    const toFieldEmails = (this.emailForm.get('to')?.value || '')
      .split(',')
      .map((e: string) => e.trim())
      .filter((e: string) => e.length > 0);
    const ccAddressParsed = Array.isArray(ccValue)
      ? ccValue
      : (ccValue as string).split(',').map((e: string) => e.trim()).filter(Boolean);
    const ccAddress: string[] = ccValue ? ccAddressParsed : [];
    const bccAddressParsed = Array.isArray(bccValue)
      ? bccValue
      : (bccValue as string).split(',').map((e: string) => e.trim()).filter(Boolean);
    const bccAddress: string[] = bccValue ? bccAddressParsed : [];
    const rawBody = this.emailForm.value.body;
    const emailBody = (rawBody && typeof rawBody === 'object') ? toHTML(rawBody) : (rawBody || '');
    const payload: any = {
      toAddress: toFieldEmails,
      emailBody: emailBody,
      emailSubject: this.emailForm.value.subject,
      ccAddress: ccAddress,
      bccAddress: bccAddress,
      projectId: this.projectId,
      templateId: this.emailForm.value.templateId ?? ''
    }

    return payload;
  }

  saveEmailDetails() {
    console.info("this.emailForm.valid", this.emailForm.value);

    if (!this.projectId) {
      console.trace('Project ID is missing. Cannot save email details.');
      return;
    }

    const payload = this.saveEmailPayload();
    this.createProjectService.setSelectedEmail(payload);
    this.createProjectService.saveEmailDrafts(this.workDayId, payload).subscribe(res => {
      console.info("email save", res)
      this.createProjectService.setSelectedTemplateId(this.emailForm.value.templateId)
      this.incrementSelectedstep();
    })
  }

   onSubmit() {
    const dialogRef = this.dialog.open(this.submitDialog, {
      width: '400px',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // User clicked Yes, send payload to save API
        const payload = {
          createdBy: this.userName,
          projectId: this.projectId,
          isSubmitted: true
        };

        console.info('Submitting project with payload:', payload);

        this.createProjectService.saveProjectDetails(payload).subscribe({
          next: (res) => {

            console.info('Project submitted successfully:', res);
            const sendemailPayload = { projectId: this.projectId , deptId: this.selectedDepartmentIds };
            this.createProjectService.sendEmailHandler(this.workDayId, sendemailPayload).subscribe({
              next: (emailRes) => {
                console.info('Email sent successfully:', emailRes);
                const successDialogRef = this.dialog.open(this.successDialog, {
                  width: '500px',
                  disableClose: true,
                  panelClass: 'custom-dialog-container'
                });

                successDialogRef.afterClosed().subscribe(() => {
                  this.isSubmitted = true;
                  this.createProjectService.setSelectedCollection(null);
                  this.createProjectService.setSelectedSubCollection([]);
                  this.router.navigate(['/dashboard']);
                });
              },
              error: (emailErr) => {
                console.trace('Error sending email:', emailErr);
              }
            });
          },
          error: (err) => {
            console.trace('Error submitting project:', err);
            const errorMsg = err?.error?.message || '✗ Error saving project. Please try again.';
            this.snackBar.open(errorMsg, 'Close', {
              duration: 5000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
              panelClass: ['error-snackbar']
            });
          }
        });
      }
    });
  }

  get isSaveDraftDisabled(): boolean {
    const depIds = this.createProjectService.getSelectedDepartmentId() || [];
    if (this.selectedStep < 2) {
      return true;
    }
    if (this.selectedStep === 2) {
      return !(Array.isArray(depIds) && depIds.length > 0);
    }
    return false;
  }

  openSaveDraftDialog() {
    const dialogRef = this.dialog.open(SaveDraftDialogComponent, {
      width: '600px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result !== 'yes') {
        return;
      }
      this.saveDraft();
    });
  }

  onCancel() { }

  private formatDate(date: any): string {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  }

  // Build a LOCAL-midnight Date from a date-only value (e.g. "2026-08-18T00:00:00.000Z")
  // so the datepicker shows the correct calendar day in timezones behind UTC.
  private parseDateOnly(value: any): Date | '' {
    if (!value) {
      return '';
    }
    const datePart = String(value).split('T')[0];
    const [year, month, day] = datePart.split('-').map(Number);
    if (!year || !month || !day) {
      return '';
    }
    return new Date(year, month - 1, day);
  }
  saveDraft() {
    console.info('Saving draft for create-project flow');

    // Save selected departments/team members as part of draft (optional)
    if (
      this.projectId &&
      ((this.selectedDepartments && this.selectedDepartments.length > 0) ||
        (this.selectedMembers && this.selectedMembers.length > 0))
    ) {
      const deptIds = Array.from(
        new Set([
          ...(this.selectedMembers || []).map(m => String(m.tm_dept_id)),
          ...(this.selectedDepartments || []).map(d => String(d.id))
        ].filter(Boolean))
      );

      const departmentDetails = deptIds.map(deptId => {
        const members = (this.selectedMembers || []).filter(m => String(m.tm_dept_id) === deptId);
        const dept = this.selectedDepartments.find(d => String(d.id) === deptId);
        const departmentName = dept?.name || '';

        const teamDetails = members.map(m => ({
          tm_workday_id: m.tm_workday_id,
          tm_name: m.tm_name || m.name || '',
          tm_email: m.tm_email || m.email || ''
        }));

        return {
          departmentId: deptId,
          departmentName,
          teamDetails,
          selectedAll: false
        };
      });

      const deptPayload = {
        projectId: this.projectId,
        departmentDetails
      };

      this.createProjectService
        .saveTeammemberDetails(this.workDayId, deptPayload)
        .subscribe({
          next: res => {
            console.info('Team members saved as part of draft:', res);
            this.router.navigate(['/dashboard'], {
              state: { isDraftSave: true }
            });
          },
          error: err => {
            console.trace('Error saving team members as part of draft:', err);
          }
        });
    }

    // Save email draft if possible, but do not advance the stepper
    if (this.projectId && this.emailForm?.valid) {
      const payload = this.saveEmailPayload();
      this.createProjectService.setSelectedEmail(payload);
      this.createProjectService.saveEmailDrafts(this.workDayId, payload).subscribe(_res => {
        this.createProjectService.setSelectedTemplateId(this.emailForm.value.templateId)
      });
    }

  }

  private clearEmailTemplateSelection() {
    // Clear selected template in common service
    this.createProjectService.setSelectedEmail(null);
    this.createProjectService.setSelectedTemplateId(null);

    // Clear email form subject and body
    this.emailForm.patchValue({
      subject: '',
      body: ''
    });
  }
}
